import WebSpeechAPI from "./WebSpeechAPI";
import { split } from "sentence-splitter";

class CrOSWebSpeechAPI extends WebSpeechAPI {
  async pause() {

    await speechSynthesis.cancel();
    this.isForcedCancel = true;

    setTimeout(() => {
      this.speechEnded = false;
    })
  }

  async cancel(isForcedCancel = false) {
    this.isForcedCancel = isForcedCancel;
    speechSynthesis.cancel();
  }

  setText(value: string, updateInitialText = true) {

    let sentences = split(value);
    let sentencesFormatted: Array<SpeechSynthesisUtterance> = [];

    this.rawSentences = [];

    sentences.map((sentence) => {
      if (sentence.type === 'Sentence') {
        this.rawSentences.push(sentence);
        return sentencesFormatted.push(new SpeechSynthesisUtterance(sentence.raw));
      }
      return false;
    })

    if(updateInitialText) {
      this.initialText = value;
    }
    this._sentencesLeftFromUtteranceArray = sentencesFormatted;
    this.speechSynthesisUtterance.text = value;
    this.sentenceIndex = 0;
    this.shift = 0;
  }


  speak(restart = false) {
    this.initializeText(restart);

    if (!this.speechEnded) {
      this._sentencesLeftFromUtteranceArray[0].text = this._sentencesLeftFromUtteranceArray[0].text.slice(this.charIndex);
    }

    this.applyCurrentUtteranceSettings();


    this.speechEnded = true;

    return new Promise((resolve) => {
      if(!this._sentencesLeftFromUtteranceArray[0]) {
        return resolve();
      }

      this._sentencesLeftFromUtteranceArray[0].onboundary = (event) => {
        this.updateBoundary(event.charIndex)
      };

      this._sentencesLeftFromUtteranceArray[0].onend = (endEvent: any) => {
        this.shift = 0;

        //Do not remove sentences from queue if text is invalid
        if (endEvent.srcElement && this._sentencesLeftFromUtteranceArray[0].text !== endEvent.srcElement.text) {
          return resolve(true);
        }
        //if(!this.isForcedCancel) { //TODO: remove check if obsolete after validation on CrOS
          this._sentencesLeftFromUtteranceArray.shift();
          this.sentenceIndex++;
        //}

        if (this._sentencesLeftFromUtteranceArray.length > 0) {
          return resolve(true);
        }
        this.sentenceIndex = 0;
        this.shift = 0;
        return resolve();
      }
      if (!this.isForcedCancel) {
        speechSynthesis.speak(this._sentencesLeftFromUtteranceArray[0]);
      } else {
        speechSynthesis.cancel();
        this.isForcedCancel = false;
        this.sentenceIndex = 0;
        this.shift = 0;
        return resolve();
      }

    })
  }


}

export default CrOSWebSpeechAPI;
